import { BellOutlined, KeyOutlined, LogoutOutlined, UserOutlined, DownOutlined } from '@ant-design/icons';
import { App, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { Fragment, useState, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from '../store/auth';
import { ChangePasswordModal } from '../components/ChangePasswordModal';

export interface TopbarProps {
  crumbs: { label: string; href?: string }[];
  rightSlot?: ReactNode;
}

export function Topbar({ crumbs, rightSlot }: TopbarProps) {
  const [pwdOpen, setPwdOpen] = useState(false);
  const admin = useAuthStore((s) => s.admin);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { modal, message } = App.useApp();

  function handleLogout() {
    modal.confirm({
      title: '退出登录',
      content: `确定要退出 @${admin?.username ?? ''} 的登录会话吗？`,
      okText: '退出',
      cancelText: '取消',
      onOk: () => {
        logout();
        qc.clear();
        message.success('已退出登录');
        navigate('/login', { replace: true });
      },
    });
  }

  const userMenu: MenuProps = {
    items: [
      {
        key: 'profile',
        icon: <UserOutlined />,
        label: (
          <div style={{ lineHeight: 1.4, minWidth: 140 }}>
            <div style={{ fontWeight: 600 }}>@{admin?.username ?? 'unknown'}</div>
            <div style={{ fontSize: 11, color: 'var(--c-fg-3)' }}>平台超管</div>
          </div>
        ),
        disabled: true,
      },
      { type: 'divider' },
      {
        key: 'change-password',
        icon: <KeyOutlined />,
        label: '修改密码',
        onClick: () => setPwdOpen(true),
      },
      {
        key: 'logout',
        icon: <LogoutOutlined />,
        label: '退出登录',
        onClick: handleLogout,
      },
    ],
  };

  const initial = (admin?.username ?? '?').charAt(0).toUpperCase();

  return (
    <>
      <header className="topbar">
        <div className="topbar__crumbs">
          {crumbs.map((c, i) => (
            <Fragment key={i}>
              {i > 0 && <span className="sep">/</span>}
              {c.href ? <a href={c.href}>{c.label}</a> : <span className="topbar__current">{c.label}</span>}
            </Fragment>
          ))}
        </div>
        <div className="topbar__actions">
          {rightSlot}
          <button type="button" className="btn btn-ghost btn-sm" title="通知"><BellOutlined /></button>
          <Dropdown menu={userMenu} trigger={['click']} placement="bottomRight">
            <button type="button" className="topbar__user" aria-label="用户菜单">
              <span className="topbar__user-avatar">{initial}</span>
              <span className="topbar__user-name">@{admin?.username ?? 'unknown'}</span>
              <DownOutlined className="topbar__user-caret" />
            </button>
          </Dropdown>
        </div>
      </header>
      <ChangePasswordModal open={pwdOpen} onClose={() => setPwdOpen(false)} />
    </>
  );
}
